import React, {Component} from 'react';
import {formatDecimal} from './../../../helpers/FormatHelper';

class Intro extends Component {
  render() {
    const {
      heading,
      diagnoses,
      clinicNumber,
      bodyConditionScore,
      obesityManagement,
      pet,
      physicalActivityAndEnvironment,
      suffix,
      intro,
      introHello,
      introCopy,
      disclaimers
    } = this.props.data;

    const {
      output,
      casuistic,
      state,
      mealsPerDay,
      feedingAmounts
    } = this.props;

    const genderLabelTerm = this.props.petData.genderLabelTerm;

    let num = (100 * output.pet.weight.current) / ((output.pet.weight.bcs - 5) * 10 + 100)
    let isHospitalisation = false;
    let isPregnancy = false;
    let isLactation = false;
    let isGrowth = false;
    let isWeightAdjustment = false;
    let isMaintenance = false;
    let extraData = null;

    switch(casuistic){
      case "hospitalisation":
        isHospitalisation = true;
      break;

      case "pregnancy": //
        isPregnancy = true;
      break;

      case "lactation":
        isLactation = true;
      break;

      case "growth":
        isGrowth = true;
      break;

      case "weight_adjustment":
        isWeightAdjustment = true;
      break;

      case "maintenance": //
        isMaintenance = true;
      break;
    }

    return (
      <div className="nppe2-fc-feeding-guidelines-intro" id="fc-screenshot-feeding-guidelines-intro">

        <div className="row">
          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__pet-copy">
              <div className="row">
                <div className="col-xs-12">
                  <p>{introHello}</p>
                  <p>{introCopy}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__pet-info">
              <p><span>{pet.species}</span>: {output.pet.breedName}</p>
              {!isNaN(output.pet.age) && <p><span>{pet.age}</span>: {output.pet.age}</p>}
              <p><span>{pet.gender}</span>: {genderLabelTerm}</p>
              {output.pet.reproductiveStatus != "Default" && <p><span>{pet.reproductiveStatus}</span>: {output.pet.reproductiveStatus}</p> }
              <p><span>{pet.breedSize}</span>: {output.pet.size}</p>
            </div>
          </div>

          {Object.keys(output.diagnoses).length> 0 ? (
            <div className="col-md-4">
              <div className="nppe2-fc-feeding-guidelines-intro__diagnoses">
                <p><strong>{diagnoses}</strong></p>

                <ul className="nppe2-fc-feeding-guidelines-intro__diagnoses-list">
                  {Object.keys(output.diagnoses).map((key,i)=>{
                      return (
                        <li
                          className="nppe2-fc-feeding-guidelines-intro__diagnoses-list-item"
                          key={i}>
                          {output.diagnoses[key]}
                        </li>
                      )
                  })}
                </ul>
              </div>
            </div>
          ) : (
            <div className="col-md-4"></div>
          )}
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__pet-name">
              <div className="row">
                <div className="col-xs-8">
                  <h3>{heading}</h3>
                </div>
              </div>
              <h1>{output.pet.name}</h1>
              <p>{clinicNumber}:{output.pet.clinicRecordNumber}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__body-condition-score">
              <p className="heading">{bodyConditionScore.heading}</p>
              <p><span>{bodyConditionScore.currentBodyWeight}</span>: {output.pet.weight.current}{suffix.kg}</p>
              {!isNaN(output.pet.weight.idealage) &&  <p><span>{bodyConditionScore.idealBodyWeight}</span>: {parseFloat(output.pet.weight.ideal).toFixed(2)}{suffix.kg}</p> }
              <p><span>{bodyConditionScore.bcs}</span>: {output.pet.weight.bcs}</p>
              <p><span>{bodyConditionScore.idealBodyWeight}</span>: {num.toFixed(2) }{suffix.kg}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__physical-activity">
              <p className="heading">{physicalActivityAndEnvironment.heading}</p>
              <p><span>{physicalActivityAndEnvironment.activityDuration}</span>: {output.activity.duration}</p>
              {output.pet.animalType != "cat" &&
                <p><span>{physicalActivityAndEnvironment.activityIntensity}</span>: {output.activity.intensity}</p>
              }
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="nppe2-fc-feeding-guidelines-intro__purina-om">
              <div className="row">

                {isMaintenance &&
                  <div className="col-md-12">
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    <p><span>{intro.maximumEnergyFromTreatsLabel}</span>: {intro.maximumEnergyFromTreats}</p>
                  </div>
                }

                {isGrowth &&
                  <div className="col-md-12">
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    <p><span>{intro.maximumEnergyFromTreatsLabel}</span>: {intro.maximumEnergyFromTreats}</p>
                  </div>
                }

                {isPregnancy &&
                  <div className="col-md-12">
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    {intro.estimatedWeekOfDelivery && <p><span>{intro.estimatedWeekOfDeliveryLabel}</span>: {intro.estimatedWeekOfDelivery.from} - {intro.estimatedWeekOfDelivery.to}</p> }
                  </div>
                }

                {isLactation &&
                  <div className="col-md-12">
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    <p><span>{intro.estimatedWeekOfWeaningLabel}</span>: {intro.estimatedWeekOfWeaning && intro.estimatedWeekOfWeaning}</p>
                  </div>
                }

                {isHospitalisation &&
                  <div className="col-md-12">
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                  </div>
                }

                {isWeightAdjustment &&
                  <div className="col-md-12">
                    <p><span>{intro.mealsPerDayLabel}</span>: {mealsPerDay}</p>
                    <p><span>{intro.dailyEnergyRequirementLabel}</span>: {intro.dailyEnergyRequirement}</p>
                    <p><span>{intro.mimimalWeightLossLabel}</span>: {intro.mimimalWeightLoss}</p>
                    <p><span>{intro.idealWeightLossLabel}</span>: {intro.idealWeightLoss}</p>
                    <p><span>{intro.maximumWeigthLossLabel}</span>: {intro.maximumWeigthLoss}</p>
                    <p><span>{intro.maximumEnergyFromTreatsLabel}</span>: {intro.maximumEnergyFromTreats}</p>
                  </div>
                }

              </div>
            </div>
          </div>

          <div className="col-md-2">
            <div className="nppe2-fc-feeding-guidelines-intro__arrow-2">
            </div>
          </div>
          <div className="col-md-4">
            <div className="nppe2-fc-feeding-guidelines-intro__disclaimer">
              <p>{disclaimers.generalFormulasCalculation}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default Intro;
